import '../Styles/Header.css';

function Header({ language }) {
	return (
		<div className="header-wrapper">
			<div className="header-flex-wrapper">
				<div role="heading" aria-level="1" className="header-map-title">{language ? language['map:title'] : 'Kend dit nitrat'}</div>
			</div>
		</div>
	)
}

export default Header;
